import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AppState } from '@app/reducers';
import { IApplicationResponse, ModulesBasedApiSuffix, formConfigs, prepareGetRequestHttpParams, setRequiredValidator } from '@app/shared';
import { CrudService, RxjsService } from '@app/shared/services';
import { loggedInUserData } from '@modules/others';
import { CreditVettingScoreConfigModel } from '@modules/others/configuration/models/credit-vetting-score-config-model';
import { UserLogin } from '@modules/others/models';
import { SalesModuleApiSuffixModels } from '@modules/sales';
import { UserModuleApiSuffixModels } from '@modules/user';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
@Component({
  selector: 'app-credit-vetting-score-config',
  templateUrl: './credit-vetting-score-config.component.html'
})
export class CreditVettingScoreConfigComponent implements OnInit {
  CreditVettingScoreConfigId = '';
  creditVettingScoreConfigForm: FormGroup;
  formConfigs = formConfigs;
  userData: UserLogin;
  regions = [];
  divisions = [];
  districts = [];
  invalidGoodScore = false;
  invalidCutOffScore = false;
  invalidBadScore = false;

  constructor(private activatedRoute: ActivatedRoute
    , private store: Store<AppState>,
    private formBuilder: FormBuilder,
    private crudService: CrudService,
    private router: Router,
    private rxjsService: RxjsService) {
    this.CreditVettingScoreConfigId = this.activatedRoute.snapshot.queryParams.id;
    this.store.pipe(select(loggedInUserData)).subscribe((userData: UserLogin) => {
      if (!userData) return;
      this.userData = userData;
    })
  }

  ngOnInit(): void {
    this.createCreditVettingScoreConfigFormGroup();
    this.getRegions();
    this.onFormControlChanges();
  }


  createCreditVettingScoreConfigFormGroup(): void {
    let creditVettingScoreConfigModel = new CreditVettingScoreConfigModel();
    this.creditVettingScoreConfigForm = this.formBuilder.group({
    });
    Object.keys(creditVettingScoreConfigModel).forEach((key) => {
      this.creditVettingScoreConfigForm.addControl(key, new FormControl(creditVettingScoreConfigModel[key]));
    });
    this.creditVettingScoreConfigForm = setRequiredValidator(this.creditVettingScoreConfigForm, ["regionId", "divisionId", "districtId", "goodScore", "cutOffScore", "badScore"]);
  }

  getCreditVettingScoreConfigDetails() {
    this.crudService.get(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.SALES_API_CREDIT_VETTING_SCORE_CONFIG, this.CreditVettingScoreConfigId, true, null, 1).subscribe(res => {
      if (res.isSuccess && res.resources && res.statusCode == 200) {
        let creditVettingScoreConfigModel = new CreditVettingScoreConfigModel(res.resources);
        this.creditVettingScoreConfigForm.patchValue(creditVettingScoreConfigModel);
      }
      setTimeout(() => {
        this.rxjsService.setGlobalLoaderProperty(false);
      }, 400);
    });
  }

  getRegions() {
    this.crudService.dropdown(ModulesBasedApiSuffix.IT_MANAGEMENT, UserModuleApiSuffixModels.UX_REGIONS,
      prepareGetRequestHttpParams(null, null,
        { CountryId: formConfigs.countryId })).subscribe((response) => {
          if (response.statusCode == 200 && response.isSuccess && response.resources) {
            this.regions = response.resources;
          }
          if (this.CreditVettingScoreConfigId) {
            this.getCreditVettingScoreConfigDetails();
          }
          else {
            this.rxjsService.setGlobalLoaderProperty(false);
          }
        });
  }

  onFormControlChanges(): void {
    this.creditVettingScoreConfigForm.get('regionId').valueChanges.subscribe((regionId: string) => {
      if (!regionId) return;
      this.creditVettingScoreConfigForm.get('divisionId').setValue('');
      this.creditVettingScoreConfigForm.get('districtId').setValue('');
      this.divisions = [];
      this.districts = [];
      this.crudService.get(ModulesBasedApiSuffix.IT_MANAGEMENT, UserModuleApiSuffixModels.UX_DIVISIONS, null, false,
        prepareGetRequestHttpParams(null, null,
          { regionId }))
        .subscribe((response: IApplicationResponse) => {
          if (response && response.resources && response.isSuccess) {
            this.divisions = response.resources;
          }
          this.rxjsService.setGlobalLoaderProperty(false);
        });
    });
    this.creditVettingScoreConfigForm.get('divisionId').valueChanges.subscribe((divisionId: string) => {
      if (!divisionId) return;
      this.creditVettingScoreConfigForm.get('districtId').setValue('');
      this.districts = [];
      this.crudService.get(ModulesBasedApiSuffix.IT_MANAGEMENT, UserModuleApiSuffixModels.UX_DIVISION_DISTRICT, null, false,
        prepareGetRequestHttpParams(null, null,
          { divisionId }))
        .subscribe((response: IApplicationResponse) => {
          if (response.statusCode == 200 && response.resources && response.isSuccess) {
            this.districts = response.resources;
          }
          this.rxjsService.setGlobalLoaderProperty(false);
        });
    });
  }

  onScoreChange() {
    this.invalidGoodScore = false;
    this.invalidCutOffScore = false;
    this.invalidBadScore = false;
    if (this.creditVettingScoreConfigForm.value.goodScore != "" && Number(this.creditVettingScoreConfigForm.value.goodScore) <= Number(this.creditVettingScoreConfigForm.value.cutOffScore)) {
      this.invalidGoodScore = true;
      this.invalidCutOffScore = true;
    }
    if (this.creditVettingScoreConfigForm.value.badScore != "" && Number(this.creditVettingScoreConfigForm.value.cutOffScore) <= Number(this.creditVettingScoreConfigForm.value.badScore)) {
      this.invalidCutOffScore = true;
      this.invalidBadScore = true;
    }
    if (this.creditVettingScoreConfigForm.value.badScore != "" && Number(this.creditVettingScoreConfigForm.value.badScore) < 1)
      this.invalidBadScore = true;
  }

  onSubmit(): void {
    if (this.creditVettingScoreConfigForm.invalid || this.invalidGoodScore || this.invalidCutOffScore || this.invalidBadScore) {
      return;
    }
    if (this.CreditVettingScoreConfigId) {
      this.creditVettingScoreConfigForm.value.modifiedUserId = this.userData.userId;
    } else {
      this.creditVettingScoreConfigForm.value.createdUserId = this.userData.userId;
    }
    let crudService: Observable<IApplicationResponse> = !this.CreditVettingScoreConfigId ? this.crudService.create(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.SALES_API_CREDIT_VETTING_SCORE_CONFIG, this.creditVettingScoreConfigForm.value, 1) :
      this.crudService.update(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.SALES_API_CREDIT_VETTING_SCORE_CONFIG, this.creditVettingScoreConfigForm.value, 1)
    crudService.subscribe((response: IApplicationResponse) => {
      if (response.isSuccess) {
        this.router.navigate(['/configuration/sales/quotations'], { queryParams: { tab: 5 }, skipLocationChange: true });
      }
    });
  }
}